import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { AllGroupsPage } from '@features/groups/components/pages/AllGroupsPage'
import { FacultiesTable } from '@features/groups/components/tables/FacultiesTable'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/all/faculties')({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load faculties'>
            <Suspense fallback={<LoadingIndicator resource='all faculties'/>}>
                <AllGroupsPage
                    title='All faculties'
                    renderTable={(columnPreset) => (
                        <FacultiesTable
                            columnPreset={columnPreset}
                            mode='all'
                            navMode='id'
                        />
                    )}
                />
            </Suspense>
        </QueryErrorBoundary>
    )
}
